/**
 * TanStack Query Provider
 *
 * Provides TanStack Query client to the React component tree
 * with proper error handling and development tools integration
 */

import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from '@/lib/query-client';
import { PropsWithChildren, ReactElement } from 'react';

import { isDev } from '@/lib';

interface QueryProviderProps extends PropsWithChildren {
  // Allow passing custom client for testing
  client?: typeof queryClient;
}

export function QueryProvider({
  children,
  client = queryClient,
}: QueryProviderProps): ReactElement {
  return (
    <QueryClientProvider client={client}>
      {children}
      {/* Development tools - only in dev mode */}
      {isDev && (
        <ReactQueryDevtools initialIsOpen={false} position="bottom" buttonPosition="bottom-right" />
      )}
    </QueryClientProvider>
  );
}
